import React from "react";
import { useLang } from "../LangContext";
import { motion } from "framer-motion";

export default function Program() {
    const { t } = useLang();
    return (
        <section id="program" data-testid="program-section" className="relative py-24 md:py-32 px-6 md:px-12 bg-inksurface">
            <div className="max-w-7xl mx-auto">
                <div className="mb-16 max-w-3xl">
                    <span className="text-xs font-mono uppercase tracking-[0.3em] text-volt">— {t.program.label}</span>
                    <h2 className="font-graffiti text-4xl md:text-6xl tracking-tight mt-6 text-white leading-[0.95]">
                        {t.program.title}
                    </h2>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-white/10 border border-white/10">
                    {t.program.steps.map((s, i) => (
                        <motion.div
                            key={i}
                            data-testid={`program-step-${i}`}
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.6, delay: i * 0.15 }}
                            className="bg-ink p-8 md:p-10 hover:bg-inksurface transition-colors group relative"
                        >
                            <div className="font-mono text-xs text-volt mb-6 tracking-[0.3em]">{s.n} / 03</div>
                            <h3 className="font-display font-bold uppercase text-2xl md:text-3xl text-white tracking-tight leading-tight">
                                {s.title}
                            </h3>
                            <p className="mt-6 text-zinc-400 leading-relaxed">{s.body}</p>
                            <div className="absolute bottom-0 left-0 h-[2px] w-0 bg-volt group-hover:w-full transition-all duration-700" />
                        </motion.div>
                    ))}
                </div>

                <div className="mt-10">
                    <a href="#donate" data-testid="program-cta" className="btn-volt inline-flex items-center gap-2 px-6 py-3 text-xs">
                        {t.nav.help} →
                    </a>
                </div>
            </div>
        </section>
    );
}
